/* global axios */
import ApiClient from './ApiClient';

class RevenueAutopilotAPI extends ApiClient {
  constructor() {
    super('revenue_autopilot', { accountScoped: true });
  }

  getDashboard(params = {}) {
    return axios.get(this.url, { params });
  }

  analyze(conversationId) {
    return axios.post(`${this.url}/analyze`, {
      conversation_id: conversationId,
    });
  }

  prepare(conversationId) {
    return axios.post(`${this.url}/prepare`, {
      conversation_id: conversationId,
    });
  }

  approve(followUpId) {
    return axios.post(`${this.url}/follow_ups/${followUpId}/approve`);
  }

  updateDraft(followUpId, proposedMessage) {
    return axios.patch(`${this.url}/follow_ups/${followUpId}`, {
      proposed_message: proposedMessage,
    });
  }

  discard(followUpId) {
    return axios.delete(`${this.url}/follow_ups/${followUpId}`);
  }
}

export default new RevenueAutopilotAPI();
